/**
 * Returns a callback URL that is safe for client-side navigation.
 *
 * Callback URLs can be supplied by an integrator and later appear in the
 * browser's query string. Keep the client boundary deliberately strict: only
 * absolute HTTPS URLs without credentials may be used for navigation.
 */
export const getSafeCallbackUrl = (value: unknown): string | undefined => {
  if (typeof value !== 'string' || value.trim() !== value) {
    return undefined;
  }

  try {
    const url = new URL(value);

    if (url.protocol !== 'https:' || !url.hostname || url.username || url.password) {
      return undefined;
    }

    return url.href;
  } catch {
    return undefined;
  }
};
